import { jsx } from "react/jsx-runtime";
import { useTranslation } from "../../../../lib/hooks/useTranslation.js";
import { useIsFullscreen } from "../../../VideoContextProvider/context/state/isFullscreen.js";
import pipIcon from "../../../../assets/icons/picture-in-picture-icon.svg.js";
import { useVideoController } from "../../../VideoContextProvider/context/videoController.js";
import { debug } from "../../../../log.js";
const debugPipButton = debug.extend("pip-button");
const PipButton = ({ onPipRequest }) => {
  const { t } = useTranslation();
  const isFullscreen = useIsFullscreen();
  const videoController = useVideoController();
  const isPictureInPictureSupported = typeof document !== "undefined" && "pictureInPictureEnabled" in document;
  const shouldRenderPipButton = isPictureInPictureSupported && !isFullscreen || onPipRequest;
  debugPipButton("### DEBUG OMEGA NPM: STEP 3 - PipButton - onPipRequest exists:", !!onPipRequest);
  debugPipButton(
    "### DEBUG OMEGA NPM: STEP 3 - PipButton - isPictureInPictureSupported:",
    isPictureInPictureSupported
  );
  debugPipButton("### DEBUG OMEGA NPM: STEP 3 - PipButton - isFullscreen:", isFullscreen);
  debugPipButton(
    "### DEBUG OMEGA NPM: STEP 3 - PipButton - shouldRenderPipButton:",
    shouldRenderPipButton
  );
  const handlePipClick = () => {
    debugPipButton(
      "### DEBUG OMEGA NPM: STEP 4 - PipButton clicked, onPipRequest exists:",
      !!onPipRequest
    );
    if (onPipRequest) {
      debugPipButton("### DEBUG OMEGA NPM: STEP 4 - Calling onPipRequest...");
      onPipRequest();
    } else {
      debugPipButton("### DEBUG OMEGA NPM ERROR: STEP 4 - onPipRequest is undefined!");
    }
    if (isPictureInPictureSupported) {
      debugPipButton("### DEBUG OMEGA NPM: STEP 4 - Calling native PiP functionality");
      videoController.togglePictureInPictureMode();
    }
  };
  if (!shouldRenderPipButton) {
    debugPipButton(
      "### DEBUG OMEGA NPM: STEP 3 - PipButton not rendering - shouldRenderPipButton is false"
    );
    return null;
  }
  return /* @__PURE__ */jsx("button", { type: "button", onClick: handlePipClick, children: /* @__PURE__ */jsx("img", { style: { minWidth: "25px" }, "aria-label": t("Picture-in-Picture"), src: pipIcon }) });
};
export {
  PipButton };
//# sourceMappingURL=dist/components/VideoContainer/VideoControlRack/PipButton/index.js.map